import { Icon, IconProps } from '@chakra-ui/react'

export function TagIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_419_23592)">
      <path
        d="M28.5467 15.44L16.5467 3.43996C16.0667 2.95996 15.4 2.66663 14.6667 2.66663H5.33335C3.86669 2.66663 2.66669 3.86663 2.66669 5.33329V14.6666C2.66669 15.4 2.96002 16.0666 3.45335 16.56L15.4534 28.56C15.9334 29.04 16.6 29.3333 17.3334 29.3333C18.0667 29.3333 18.7334 29.04 19.2134 28.5466L28.5467 19.2133C29.04 18.7333 29.3334 18.0666 29.3334 17.3333C29.3334 16.6 29.0267 15.92 28.5467 15.44ZM17.3334 26.68L5.33335 14.6666V5.33329H14.6667V5.31996L26.6667 17.32L17.3334 26.68V26.68Z"
        fill="currentColor"
      />
      <path
        d="M8.66669 10.6666C9.77126 10.6666 10.6667 9.7712 10.6667 8.66663C10.6667 7.56206 9.77126 6.66663 8.66669 6.66663C7.56212 6.66663 6.66669 7.56206 6.66669 8.66663C6.66669 9.7712 7.56212 10.6666 8.66669 10.6666Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_419_23592">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
